import { render } from "./GlobalSettings.vue?vue&type=template&id=37def3f5&scoped=true"
import script from "./GlobalSettings.vue?vue&type=script&lang=js"
export * from "./GlobalSettings.vue?vue&type=script&lang=js"

import "./GlobalSettings.vue?vue&type=style&index=0&id=37def3f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37def3f5"]])

export default __exports__